import { NgModule } from '@angular/core';

/**
 * We must import all api services here
 */
import { LaunchService } from './launch.service';
import { OrganizationService } from './organization.service';
import { QuestionService } from './question.service';
import { PermissionService } from './permission.service';
import { ResponseService } from './response.service';
import { ResultsService } from './results.service';
// import { MockDataService } from './mockdata.service';
import { AuthenticationService } from './authentication.service';
import { LaunchOrchestratorService } from './launch-orchestrator.service';
import { ImportLaunchService } from './import-launch.service';

const apiServices = [
    AuthenticationService,
    LaunchService,
    OrganizationService,
    QuestionService,
    PermissionService,
    ResponseService,
    ResultsService,
    // MockDataService,
    LaunchOrchestratorService,
    ImportLaunchService
]

@NgModule({
    providers: [...apiServices]
})
export class ApiModule {}
